import type { ComponentProps } from "react";
import { Tabs as TabsPrimitive } from "radix-ui";
import { tv } from "tailwind-variants";

const tabVariant = tv({
  slots: {
    root: "",
    list: "inline-flex w-full items-end justify-center text-neutral-700",
    trigger:
      "group inline-flex flex-1 items-center justify-center border-b-2 border-neutral-400 px-3 py-2 text-sm font-medium whitespace-nowrap transition-all focus-visible:ring-2 focus-visible:ring-secondary-200 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-neutral-800 data-[state=active]:font-semibold data-[state=active]:text-neutral-800",
    content:
      "focus-visible:ring-secondary- grow flex-col ring-offset-secondary-200 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden",
  },
});

const { root, list, trigger, content } = tabVariant();

const Root = ({
  className,
  ...props
}: ComponentProps<typeof TabsPrimitive.Root>) => {
  return <TabsPrimitive.Root {...props} className={root({ className })} />;
};

const List = ({
  className,
  ...props
}: ComponentProps<typeof TabsPrimitive.List>) => {
  return <TabsPrimitive.List className={list({ className })} {...props} />;
};

const Trigger = ({
  className,
  ...props
}: ComponentProps<typeof TabsPrimitive.Trigger>) => {
  return (
    <TabsPrimitive.Trigger className={trigger({ className })} {...props} />
  );
};

const Content = ({
  className,
  ...props
}: ComponentProps<typeof TabsPrimitive.Content>) => {
  return (
    <TabsPrimitive.Content className={content({ className })} {...props} />
  );
};

export const Tabs = { Root, List, Trigger, Content };
